export const getDITelemetryProperties = (inputs) => {
  const inputsWithSelection = inputs.filter((item) => !!item.selection);

  const {
    selected_drug_codes,
    selected_drug_names,
  } = inputsWithSelection.reduce(
    (acc, drug) => {
      const { code } = drug.selection?.metadata;
      const { completion } = drug.selection;

      if (code) {
        acc.selected_drug_codes.push(code);
      }
      if (completion) {
        acc.selected_drug_names.push(completion);
      }

      return acc;
    },
    { selected_drug_codes: [], selected_drug_names: [] }
  );

  return { selected_drug_codes, selected_drug_names };
};
